// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KMMh","question":"styles_question__1r5hT","description":"styles_description__F_Sep"};